import React from 'react'
import PlayerScreen from 'components/playerScreen'
import { COMMON } from 'utils/intl/common'
import { iconArrowRight } from 'utils/icons'

function SectionTryQovery(props) {
  const { video, title, description } = props

  return (
    <div className="section section-try-qovery">
      <div className="container">
        <div className="row">
          <div className="col col--center col-md-10 col-lg-6 ft-center">
            <h2 className="h1 h1--large c-white ft-center mb-2 mb-md-3">{title}</h2>
            <p className="c-white ft-primary mb-5" dangerouslySetInnerHTML={{ __html: description }} />
            <a className="btn mb-5 mb-md-8" href="https://start.qovery.com" rel="noopener noreferrer">
              {COMMON.SECTION_TRY_QOVERY_LINK}
              {iconArrowRight}
            </a>
          </div>
        </div>
        <div className="row">
          <div className="section-try-qovery__image col col--center col-md-10">
            <PlayerScreen image="../images/hero-video.jpg" alt="Qovery console" video={video} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionTryQovery
